import clsx from 'clsx';
import React from 'react';
import classes from './TooltipCardContainer.module.css';
import { MantineColor, MantineSize } from '@mantine/core';
import { toMantineCssVar } from '@vision/ui/utils/css.utils';

export interface TooltipCardContainerProps {
  accentColor?: MantineColor;
  className?: string;
  variant?: 'default' | 'light';
  size?: MantineSize;
}

export function TooltipCardContainer({
  accentColor = 'blue.5',
  children,
  className,
  variant,
  size = 'md',
}: React.PropsWithChildren<TooltipCardContainerProps>) {
  return (
    <div
      className={clsx(classes.tooltipCard, className, {
        [classes.tooltipCardLight]: variant === 'light',
      })}
    >
      <div
        className={clsx(classes.tooltipCardContent, {
          [classes.sm]: size === 'sm',
          [classes.md]: size === 'md',
        })}
        style={{ '--tooltip-accent-color': toMantineCssVar(accentColor) } as React.CSSProperties}
      >
        {children}
      </div>
    </div>
  );
}
